// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-3DGZT";
var _3 = "close__text-1JZgH";
var _4 = "header_wrapper-2PFDf";
export { _1 as "__esModule", _2 as "title", _3 as "close__text", _4 as "header_wrapper" }
export default { "__esModule": _1, "title": _2, "close__text": _3, "header_wrapper": _4 }
